import { getModuleForAdminQuery, Module, ModuleType, PageType, QuestionType } from "./API.service";

export type AdminUser = {
  Attributes: Array<{
    Name: string,
    Value: string
  }>,
  Username: string    
}

export type AdminListUserResponse = {
  Users: Array<AdminUser>,
  NextToken: string
}

export class ViewModule {
  id: string;
  label: string;
  type: ModuleType;
  users: ViewModuleUserMap;
  usersOrderedIDs: Array<string>;
  questions: ViewQuestionMap;
  questionsOrderedIDs: Array<string>;

  async init(users: Array<AdminUser>, input: getModuleForAdminQuery | Module) {
    this.id = input.id;
    this.label = input.label;
    this.type = input.type;
    this.users = new ViewModuleUserMap();
    this.usersOrderedIDs = [];
    this.questions = new ViewQuestionMap();

    this.questionsOrderedIDs = new Array<string>(input.pages.items.length);

    input.pages.items.forEach((page) => {

      if (page.type == PageType.QUESTION){

        var question = page.question;

        this.questionsOrderedIDs[question.order] = question.id;

        var choices = new ViewChoiceMap();
        var choiceIdsOrdered = new Array<string>(
          question.choices ? question.choices.items.length : 0
        );
  
        var correctAnswerChoiceIds = [];
  
        var correctAnswers = question.answers.items.filter(
          (a) => a.correctness == 100
        );
  
        correctAnswers.forEach((answer) => {
          answer.choices.items
            .map((ac) => ac.choice.id)
            .forEach((ac) => correctAnswerChoiceIds.push(ac));
        });
  
        
        var scaleLength = -1;
        var defaultMinLabel = null;
        var defaultMaxLabel = null;
        if (question.type == QuestionType.LIKERT){
  
          if (question.data){
            var questionData = JSON.parse(question.data)
            scaleLength = questionData["scaleLength"];
            defaultMinLabel = questionData["defaultMinLabel"];
            defaultMaxLabel = questionData["defaultMaxLabel"];
          }
        }
  
        question.choices.items.forEach((choice) => {
          choiceIdsOrdered[choice.order] = choice.id;
  
          var correct = false;
  
          correct = correctAnswerChoiceIds.includes(choice.id);
  
          var responses = []
  
          var choiceValue = choice.value
  
          if (question.type == QuestionType.LIKERT && scaleLength > 0) {
  
            responses = new Array(scaleLength).fill(0)
            choiceValue = JSON.parse(choice.value)
          }
  
          choices.set(choice.id, {
            value: choiceValue,
            order: choice.order,
            responses: responses,
            correct: correct,
          });
        });
  
        var q = new ViewQuestion(
          question.value,
          question.type,
          choices,
          choiceIdsOrdered,
          new ViewUserResponseMap(),
          correctAnswerChoiceIds,scaleLength,
          defaultMinLabel,
          defaultMaxLabel
        );
  
        this.questions.set(question.id, q);

      }

    })

    this.questionsOrderedIDs = this.questionsOrderedIDs.slice(0, this.questions.size);

    input.runs.items.forEach((run) => {

      var cognitoUser = users.filter(
        (u) =>
          u.Attributes.filter((a) => a.Name == 'sub')[0].Value == run.userID
      )[0]

      var username = "Anonymous";
      if (cognitoUser){
        var username = cognitoUser.Username;
      }
      
      this.users.set(run.userID, {
        id: run.userID,
        name: username,
        mark: 0
      });

      if (run.responses.items.length == this.questions.size) {
        run.responses.items.forEach((response) => {
          var question = this.questions.get(response.questionID);

          var choices = [];
          var correct = false;

          var responseValue = response.value;

          if (
            question.type == QuestionType.MULTIPLE_CHOICE ||
            question.type == QuestionType.MULTIPLE_SELECT
          ) {
            if (
              question.answerChoiceIDs.length == response.choices.items.length
            ) {
              correct = this.type == ModuleType.TEST;
            }

            response.choices.items.forEach((c) => {
              correct =
                correct && question.answerChoiceIDs.includes(c.choiceID);

              var choice = question.choices.get(c.choiceID);

              choices.push({
                id: c.choiceID,
                value: choice.value,
              });

              choice.responses.push(run.userID);
            });
          } else if (
            question.type == QuestionType.LONG_FORM ||
            question.type == QuestionType.SHORT_FORM
          ) {
            correct = this.type == ModuleType.TEST && response.correctness == 100;
          } else if (
            question.type == QuestionType.LIKERT
          ){
            correct = this.type == ModuleType.TEST && response.correctness == 100;
            responseValue = <Array<number>>JSON.parse(responseValue);

            responseValue.forEach((rv, i) => {
              (question.choicesOrdered[i].responses)[rv] += 1
            })

          }

          if (correct) {
            this.users.get(run.userID).mark++;
          }

          question.userResponses.set(run.userID, {
            name: username,
            response: {
              id: response.id,
              choices: choices,
              value: responseValue,
              correct: correct,
            },
          });
        });
      }

    });

    this.sortUsersByName();
  }

  sortUsersByName(direction: string = 'asc') {
    this.usersOrderedIDs = Array.from(this.users.entries())
      .sort((a, b) =>
        direction == 'asc' || direction == ''
          ? a[1].name.localeCompare(b[1].name)
          : b[1].name.localeCompare(a[1].name)
      )
      .map((u) => u[0]);
  }

  sortUsersByMark(direction: string = 'asc') {
    this.usersOrderedIDs = Array.from(this.users.entries())
      .sort((a, b) =>
        direction == 'asc' || direction == ''
          ? a[1].mark - b[1].mark
          : b[1].mark - a[1].mark
      )
      .map((u) => u[0]);
  }

  get questionsOrdered(): Array<ViewQuestion> {
    return this.questionsOrderedIDs.map((q) => this.questions.get(q));
  }

  get usersOrdered(): Array<ViewModuleUser> {
    return this.usersOrderedIDs.map((u) => this.users.get(u));
  }

  getMark(userId): number {
    
    if (this.type == ModuleType.SURVEY) {
      return -1;
    }

    if (this.questions.size == 0) {
      return -1
    }
    
    if (this.users.has(userId)) {
      return this.users.get(userId).mark
    }

    return 0;

  }
  
}

export class ViewModuleMap extends Map<string, ViewModule> {}

export type ViewUserResponse = {
    name: string;
    response: {
      id: string;
      value: string;
      choices: Array<{
        id: string;
        value: string;
      }>;
      correct: boolean;
    };
  }

export class ViewUserResponseMap extends Map<
  string,
  ViewUserResponse
> {}

export class ViewChoice {
  value: string | Array<string>;
  order: number;
  responses: Array<string>;
  correct: boolean;
}

export class ViewChoiceMap extends Map<string, ViewChoice> {}

export class ViewQuestion {
  value: string;
  type: QuestionType;
  choices: ViewChoiceMap;
  choiceIDsOrdered: Array<string>;
  userResponses: ViewUserResponseMap;
  answerChoiceIDs: Array<string>;
  scaleLength: number;
  defaultMinLabel: string;
  defaultMaxLabel: string;
  scaleOptionArray: Array<number>;

  constructor(
    value: string,
    type: QuestionType,
    choices: ViewChoiceMap,
    choiceIDsOrdered: Array<string>,
    userResponses: ViewUserResponseMap,
    answerChoiceIds: Array<string>,
    scaleLength: number,
    defaultMinLabel: string,
    defaultMaxLabel: string
  ) {
    this.value = value;
    this.type = type;
    this.choices = choices;
    this.choiceIDsOrdered = choiceIDsOrdered;
    this.userResponses = userResponses;
    this.answerChoiceIDs = answerChoiceIds;
    this.scaleLength = scaleLength;
    this.defaultMinLabel = defaultMinLabel;
    this.defaultMaxLabel = defaultMaxLabel;
    if (scaleLength > 0) {
      this.scaleOptionArray = Array(scaleLength).fill(null).map((x,i) => i);
    } else {
      this.scaleOptionArray = [];
    }
  }

  get choicesOrdered(): Array<ViewChoice> {
    return this.choiceIDsOrdered.map((c) => this.choices.get(c));
  }

}

export class ViewQuestionMap extends Map<string, ViewQuestion> {}

export class ViewModuleUser {
  id: string;
  name: string;
  mark: number;
}

export class ViewModuleUserMap extends Map<string, ViewModuleUser> {}
